<template>
  <div class="mr--4 sales__items">
    <template v-for="(item, index) in items">
      <product
        :key="`salesthumbnail_${index}`"
        :thumbnail="item.product.thumb"
        thumbnail-size="smaller"
        :name="getProductName(item)"
        :price="item.product.formatted_price"
        :size="item.size || item.product.size_info"
        :url="item.product.site_url"
      />
    </template>
  </div>
</template>

<script>
import utilsMixin from '@/_utilities/utilsMixin';

export default {
  name: 'SalesItems',
  mixins: [utilsMixin],
  props: {
    name: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>

.sales__items{
  display: grid;
  grid-template-columns: repeat(auto-fit, 65px);
  row-gap: 1px;
  column-gap: 1px;
}
</style>
